<template>
  <div>
    <v-list-item
      @click="expanded = !expanded"
      :key="selection.id + market.type + 'item'"
      :class="{
        'profit-med': marginColor === 'darkorange',
        'profit-high': marginColor === 'green'
      }"
    >
      <v-list-item-title class="selection">
        <span v-if="isFvFMarket()" :class="{ scratched: selection.scratched }">
          {{ selection.name }}
        </span>
        <span v-else :class="{ scratched: selection.scratched }">
          {{ selection.number }}. {{ selection.name }}
        </span>
      </v-list-item-title>
      <template v-if="bookiePrice && bestBetfairPrice && !selection.scratched">
        <v-list-item-subtitle class="text-right selection-price bookie">
          <span>{{ bookiePrice }} </span>
        </v-list-item-subtitle>
        <v-list-item-subtitle class="text-right selection-price betfair">
          <span>{{ bestBetfairPrice }}</span>
        </v-list-item-subtitle>
        <v-list-item-subtitle class="text-right selection-price margin">
          <span :style="{ color: marginColor }">{{ marginFormatted }}</span>
        </v-list-item-subtitle>
      </template>
    </v-list-item>
    <v-list-item
      v-if="expanded"
      @click="expanded = !expanded"
      :key="selection.id + market.type + '-item-prices'"
    >
      <div
        v-for="(price, index) of betfairPrices.filter(p => p[1]).slice(0, 7)"
        :key="selection.id + market.type + '-price-' + index"
        :class="{
          ladder: true,
          'bf-first': index === 0,
          'bf-type-lay': true,
          'bf-type-back': false
        }"
      >
        <div
          :class="{
            'bf-price': true
          }"
        >
          {{ price[0] }}
        </div>
        <div class="bf-volume">${{ price[1].toFixed(0) }}</div>
      </div>
    </v-list-item>
  </div>
</template>

<script>
export default {
  name: "RunnerItem",
  props: ["selection", "race", "market"],
  components: {},
  data() {
    return {
      expanded: false
    };
  },
  methods: {
    isFvFMarket() {
      return this.market.type === "FAV_FIELD";
    }
  },
  computed: {
    bookiePrice: function() {
      const p = this.$store.getters.getBookiePrice(
        this.race.bot,
        this.race.id,
        this.selection.number,
        this.selection.marketType
      );
      return p || 0;
    },
    betfairPrices: function() {
      if (this.selection.type === "FIELD") {
        const prices = this.$store.getters.getBetfairPrices(
          this.race.bot,
          this.market.betfairID,
          this.selection.betfairID,
          "back"
        );

        return prices.map(p => [
          Math.round(100 * (1 / (p[0] - 1) + 1)) / 100,
          p[1]
        ]);
      } else {
        return this.$store.getters.getBetfairPrices(
          this.race.bot,
          this.market.betfairID,
          this.selection.betfairID,
          "lay"
        );
      }
    },
    bestBetfairPrice: function() {
      const p = this.betfairPrices;
      if (!p) return 0;

      return p[0][0] || 0;
    },
    margin: function() {
      if (!this.bookiePrice || !this.bestBetfairPrice) return 0;

      return 100 * (this.bookiePrice / this.bestBetfairPrice - 1);
    },
    marginFormatted: function() {
      const m = this.margin;

      const decimals = Math.abs(m) > 15 ? 0 : 1;

      return m.toFixed(decimals) + "%";
    },
    marginColor: function() {
      let col = "red";
      if (this.margin > 10) {
        col = "green";
      } else if (this.margin > 0) {
        col = "darkorange";
      }

      return col;
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.selection span {
  font-size: 1.1em;
  font-weight: 500;
}

.selection-price {
  max-width: 50px;
}

.selection-price.margin {
  max-width: 50px;
}

.bookie span {
  color: royalblue;
}

.betfair span {
  color: palevioletred;
}

.scratched {
  text-decoration: line-through;
  opacity: 0.7;
}

.profit-high {
  background-color: rgba(146, 241, 146, 0.4);
}

.profit-med {
  background-color: rgba(245, 219, 163, 0.4);
}

.ladder {
  text-align: center;
  width: 50px;

  .bf-price {
    width: 100%;
    font-weight: 700;
    display: inline-block;
    font-size: 0.8em;
  }

  .bf-volume {
    width: 100%;
    display: inline-block;
    font-size: 0.7em;
  }
}

.bf-first.bf-type-lay {
  background-color: #fac9d4;
}
</style>
